import { ImagesService } from './service/images.service';
import { Component, Inject, Renderer2, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LOCALE_ID } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import 'parse';
const parse: typeof Parse = require('parse');
import { ParseService } from './service/parse.service';
import { Globals } from './GlobalsExport';
import { TchekOldService } from './service/tchek-old.service';
import { Location } from '@angular/common';
import { LocalstorageService } from './service/localstorage.service';
declare const $: any;
declare const ska : any

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  finish: boolean;
  hideNavbar: boolean;
userId
  constructor(
    public _location: Location,
    @Inject(DOCUMENT) private doc: Document,
    @Inject(LOCALE_ID) private locale: string,
    private renderer: Renderer2,
    public _globals: Globals,
    public tchekSvc: TchekOldService,
    private readonly _router: Router,
    private _parseService: ParseService,
    private _localStorageService: LocalstorageService
  ) {
    this.hideNavbar = false;
    this.finish = false;
  }

  ngOnInit() {

    if (environment.isLocal) {
      let path = window.location.origin;
      path = path.replace(':4200', '');
      if (!environment.isArnavaux) {
        environment.baseURL = path;
      } else {
        path = environment.baseURL
      }
      environment.baseURLPictureLocal = path + ':1337/public/images/';
      environment.parseAPILocal = path + ':1337/api';
      
     
      this._parseService.initialize();
    }
   
    const currentUser = parse.User.current();
	
	if (currentUser){
	let username = parse.User.current().getUsername()
 	
 }
	 

	if (currentUser) {
      currentUser.fetchWithInclude(['companyPtr', 'settingsPtr', 'companyPtr.iamPtr', 'companyPtr.settingsPtr', 'companyPtr.settingsPtr.APITokenPtr']).then((user) => {
        this.finish = true;
        // console.log('sbe settings',parse.User.current().get('companyPtr').get('settingsPtr'))
        if (!environment.isLocal && user.get('companyPtr').get('iamPtr')) {
          // console.log("sbe ",parse.User.current().get('companyPtr'))
          environment.accessKeyId = user.get('companyPtr').get('iamPtr').get('accessKeyId');
          environment.secretAccessKey = user.get('companyPtr').get('iamPtr').get('secretAccessKey');
        }
        // console.log('user perms', parse.User.current().get('permissionPtr'));
      }, (err) => {
        console.warn('Invalid session redirecting ...', err);
        this._localStorageService.clear();
        window.location.replace('/user/signin');
      });
    } else {
      this.finish = true;
    }
    // Enabling tooltips
    $(document).ready(function () {
      ($('body') as any).tooltip({ selector: '[data-toggle=tooltip]' }).click(function () {
        ($('[data-toggle="tooltip"]') as any).tooltip('hide');
      });
    });
    this.renderer.setAttribute(this.doc.documentElement, 'lang', this.locale);

    // Hide the navbar when in fullscreen components (e.g. AnimationComponent)
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd && (event.url.startsWith('/player') || event.url.startsWith('/user') || event.url.startsWith('/underbody') || event.url.startsWith('/viewer') || event.url.startsWith('/classificationImage')))
        this.hideNavbar = true;
      else
        this.hideNavbar = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts